import { type CSSProperties, useState } from 'react'

import { NewMessageFanDto } from '@api'

import { CreatorAvatar } from '@/modules/creators/ui/CreatorAvatar'
import { classNames } from '@/utils/helpers'

export interface NewMessageFan extends NewMessageFanDto {
  isSelected?: boolean
}

interface Props {
  style?: CSSProperties
  chatter: NewMessageFan
  isSelected?: boolean
  onClick: (fan: NewMessageFan) => void | Promise<void>
  disabled?: boolean
  enableMultiSelect?: boolean
}

export const NewMessageUsersListItem = ({
  style,
  chatter,
  onClick,
  enableMultiSelect,
}: Props) => {
  const [isActionLoading, setIsActionLoading] = useState(false)
  const { avatar, avatarThumbs, displayName, name, username, isSelected } =
    chatter

  const handleClick = async () => {
    if (isActionLoading) return

    setIsActionLoading(true)
    await onClick(chatter)
    setIsActionLoading(false)
  }

  return (
    <div
      className={classNames(
        'flex w-full flex-col px-3 py-4 pb-0',
        isActionLoading
          ? 'opacity-50'
          : 'hover:bg-primary-50 dark:hover:bg-primary-900 cursor-pointer',
      )}
      style={style}
      onClick={handleClick}
    >
      <div className="flex flex-1 items-center gap-3 overflow-hidden pb-4">
        {enableMultiSelect && (
          <div
            className={classNames(
              'border-secondary-100 h-4 w-4 shrink-0 rounded-full border',
              isSelected && 'border-primary-500 border-[6px]',
            )}
          />
        )}
        <CreatorAvatar
          size={50}
          avatarSrc={avatarThumbs?.c50 ?? avatarThumbs?.c144 ?? avatar}
          name={displayName ?? name}
          className="shrink-0"
        />
        <div className="flex-1 space-y-0.5 overflow-hidden text-ellipsis">
          <p className="flex items-center gap-2 font-medium leading-[26px]">
            <span className="whitespace-nowrap font-medium">
              {displayName || name}
            </span>

            {displayName && (
              <span className="text-secondary-300 overflow-hidden text-ellipsis whitespace-nowrap">
                ({name})
              </span>
            )}
          </p>
          <p className="text-sm leading-[22px]">{username}</p>
        </div>
      </div>
      <div className="ml-[62px] border-b" />
    </div>
  )
}
